/* =========================================================================
   MK_TARIFAS - Tarificador de envios + barra de envio gratis
   Modulo unico. Consolida los 7 archivos que antes vivian separados en
   rebajas.cl (x_tarificador-cart-rates-*.js y x_shipping-bar.js).

   Namespace: window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR
   CSS del modulo: assets/mk_tarifas.css.liquid

   Orden de los bloques = orden de dependencia. No reordenar:
     1. STORAGE   localStorage de region/comuna
     2. UI        boton del header + formato de moneda
     3. SYNC      sincronizacion popup <-> carrito
     4. POPUP     popup del header (openShippingPopup / saveShippingLocation)
     5. CART      selector y calculo de tarifas en el carrito
     6. INIT      orquestador: carga provincias y engancha listeners
     7. BAR       barra de progreso de envio gratis + ETA (#shipping-bar)

   Eventos que emite:
     shipping:location:changed  { province, city }
     shipping:rates:updated     { rates, province, city }
   ========================================================================= */


/* =========================================================================
   1. STORAGE - LocalStorage de la seleccion region/comuna
   ========================================================================= */
(function() {
  'use strict';
  
  window.HACIENDOLA = window.HACIENDOLA || {};
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR = window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR || {};
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS = window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS || {};
  
  /**
   * Guarda la selección actual de región y comuna en localStorage
   */
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.saveSelection = () => {
    // Priorizar los selectores del popup si están visibles
    let provinceSelect = document.getElementById('popupProvinceSelect');
    let citySelect = document.getElementById('popupCitySelect');
    
    // Si el popup no está visible o no existe, usar los del carrito
    const popup = document.getElementById('shippingPopup');
    if (!popup || popup.style.display === 'none') {
      provinceSelect = document.getElementById('pscCartDropdownProvinceSelect');
      citySelect = document.getElementById('pscCartDropdownCitySelect');
    }
    
    // Si ninguno de los dos existe, intentar con el que esté disponible
    if (!provinceSelect) {
      provinceSelect = document.getElementById('pscCartDropdownProvinceSelect') || document.getElementById('popupProvinceSelect');
    }
    if (!citySelect) {
      citySelect = document.getElementById('pscCartDropdownCitySelect') || document.getElementById('popupCitySelect');
    }
    
    const selection = {
      province: provinceSelect?.value || null,
      city: citySelect?.options?.[citySelect.selectedIndex]?.text || null,
      timestamp: Date.now()
    };
    
    try {
      localStorage.setItem('haciendola_shipping_selection', JSON.stringify(selection));
    } catch(e) {
      console.warn('LocalStorage not available:', e);
    }
  };

  /**
   * Carga la selección guardada desde localStorage
   * @returns {Object} { province, city } o valores null si no existe/expiró
   */
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.loadSelection = () => {
    try {
      const saved = localStorage.getItem('haciendola_shipping_selection');
      if (saved) {
        const selection = JSON.parse(saved);
        // Validar que no sea muy antigua (más de 1 hora)
        if (Date.now() - selection.timestamp < 3600000) {
          return selection;
        }
      }
    } catch(e) {
      console.warn('Error loading from LocalStorage:', e);
    }
    return { province: null, city: null };
  };
})();

/* =========================================================================
   2. UI - Boton del header y formateo de moneda
   ========================================================================= */
(function() {
  'use strict';
  
  window.HACIENDOLA = window.HACIENDOLA || {};
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR = window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR || {};
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS = window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS || {};
  
  /**
   * Actualiza el botón del header con la ubicación seleccionada
   */
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.updateHeaderButton = () => {
    const headerBtn = document.getElementById('shippingLocationValue');
    if (!headerBtn) return;
    
    const provinceSelect = document.getElementById('pscCartDropdownProvinceSelect') || document.getElementById('popupProvinceSelect');
    const citySelect = document.getElementById('pscCartDropdownCitySelect') || document.getElementById('popupCitySelect');
    
    const pinIcon = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" style="width: 16px; height: 16px; display: inline-block; vertical-align: middle; margin-right: 4px;">
      <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
      <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z" />
    </svg>`;
    
    let cityName = null;

    // NUEVO: Verificar si hay un cliente logueado con dirección
    if (window.customerAddress && window.customerAddress.city) {
      cityName = window.customerAddress.city;
      headerBtn.innerHTML = `${pinIcon}<span>Enviar a ${cityName}</span>`;
      return;
    }

    // Intentar obtener de los selectores actuales
    if (provinceSelect && citySelect && citySelect.value && citySelect.value !== '0') {
      cityName = citySelect.options[citySelect.selectedIndex].text;
    }
    
    // Si no se encontró, cargar desde localStorage
    if (!cityName) {
      const savedSelection = window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.loadSelection();
      if (savedSelection.city) {
        cityName = savedSelection.city;
      }
    }

    // Actualizar contenido del botón
    headerBtn.innerHTML = cityName 
      ? `${pinIcon}<span>Enviar a ${cityName}</span>`
      : `${pinIcon}<span>Selecciona tu ubicación</span>`;
  };

  /**
   * Formatea un número como moneda chilena
   * @param {number|string} amount - Monto a formatear
   * @returns {string} Monto formateado
   */
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.numberformat = (amount) => {
    amount += '';
    amount = parseFloat(amount.replace(/[^0-9\.]/g, ''));
    const decimals = window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.decimalValues || 0;
    
    if (isNaN(amount) || amount === 0) {
      return parseFloat(0).toFixed(decimals);
    }
    
    amount = '' + amount.toFixed(decimals);
    const amount_parts = amount.split('.');
    const regexp = /(\d+)(\d{3})/;
    
    while (regexp.test(amount_parts[0])) {
      amount_parts[0] = amount_parts[0].replace(regexp, '$1' + '.' + '$2');
    }
    
    return amount_parts.join('.');
  };
})();

/* =========================================================================
   3. SYNC - Sincronizacion bidireccional popup <-> carrito
   ========================================================================= */
(function() {
  'use strict';
  
  window.HACIENDOLA = window.HACIENDOLA || {};
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR = window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR || {};
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS = window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS || {};
  
  /**
   * Sincroniza selectores entre popup y carrito
   * @param {string} sourceType - 'popup' o 'cart'
   * @param {string} provinceCode - Código de la provincia
   * @param {string} cityName - Nombre de la ciudad
   */
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.syncSelectors = (sourceType, provinceCode, cityName) => {
    console.log('🔄 Sincronizando desde:', sourceType, { provinceCode, cityName });
    
    // Prevenir loops infinitos
    if (window.HACIENDOLA._syncing) {
      console.log('⏭️ Ya sincronizando, saltando...');
      return;
    }
    window.HACIENDOLA._syncing = true;
    
    // Determinar selectores origen y destino
    let targetProvinceSelect, targetCitySelect;
    
    if (sourceType === 'popup') {
      targetProvinceSelect = document.getElementById('pscCartDropdownProvinceSelect');
      targetCitySelect = document.getElementById('pscCartDropdownCitySelect');
    } else {
      targetProvinceSelect = document.getElementById('popupProvinceSelect');
      targetCitySelect = document.getElementById('popupCitySelect');
    }
    
    if (!targetProvinceSelect || !targetCitySelect) {
      console.log('⚠️ Selectores destino no encontrados');
      window.HACIENDOLA._syncing = false;
      return;
    }
    
    // Sincronizar provincia
    if (provinceCode && provinceCode !== '0') {
      targetProvinceSelect.value = provinceCode;
      
      const provinces = window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.provincesWithCities || [];
      const selectedProvince = provinces.find(x => x.provinceCode == provinceCode);
      
      if (selectedProvince) {
        const textValues = window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.textValues || {};
        let htmlCities = '<option value="0">' + (textValues['CHOOSE_CITY_TEXT'] || '') + '</option>';
        
        selectedProvince.provinceCities.forEach(
          x => (htmlCities += '<option value="' + x.cityName + '">' + x.cityName + '</option>')
        );
        
        targetCitySelect.innerHTML = htmlCities;
        targetCitySelect.disabled = false;
        targetCitySelect.classList.remove('hidden');
        
        console.log('✅ Provincia sincronizada, ciudades cargadas:', selectedProvince.provinceCities.length);
      }
    }
    
    // Sincronizar ciudad con delay
    setTimeout(() => {
      if (cityName && targetCitySelect.options.length > 1) {
        let cityFound = false;
        
        for (let i = 0; i < targetCitySelect.options.length; i++) {
          if (targetCitySelect.options[i].text === cityName) {
            targetCitySelect.selectedIndex = i;
            targetCitySelect.value = targetCitySelect.options[i].value;
            cityFound = true;
            console.log('✅ Ciudad sincronizada:', cityName);
            break;
          }
        }
        
        if (!cityFound) {
          console.warn('⚠️ Ciudad no encontrada:', cityName);
        }
      }
      
      window.HACIENDOLA._syncing = false;
    }, 100);
  };
})();

/* =========================================================================
   4. POPUP - Popup del header para elegir region y comuna
   ========================================================================= */
(function() {
  'use strict';
  
  window.HACIENDOLA = window.HACIENDOLA || {};
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR = window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR || {};
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS = window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS || {};
  
  /**
   * Abre el popup de selección de ubicación
   */
  window.openShippingPopup = () => {
    const popup = document.getElementById('shippingPopup');
    if (popup) {
      popup.style.display = 'flex';
    }
  };

  /**
   * Cierra el popup de selección de ubicación
   */
  window.closeShippingPopup = () => {
    const popup = document.getElementById('shippingPopup');
    if (popup) {
      popup.style.display = 'none';
    }
  };

  /**
   * Guarda la ubicación seleccionada en el popup y cierra
   */
  window.saveShippingLocation = () => {
    const citySelect = document.getElementById('popupCitySelect');
    const provinceSelect = document.getElementById('popupProvinceSelect');
    
    if (!citySelect || !provinceSelect) return;
    
    const provinceSelected = provinceSelect.value !== '0';
    const citySelected = citySelect.value !== '0';
    
    if (!provinceSelected || !citySelected) {
      alert('Por favor selecciona una región y comuna');
      return;
    }
    
    // La sincronización ya se hizo en el evento change del select
    window.closeShippingPopup();
  };

  /**
   * Configura los event listeners del popup
   */
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.setupPopupListeners = (provinces, savedSelection) => {
    const popupProvinceSelect = document.getElementById('popupProvinceSelect');
    const popupCitySelect = document.getElementById('popupCitySelect');

    if (!popupProvinceSelect || !popupCitySelect || provinces.length === 0) return;

    // Cargar provincias en el popup
    const htmlRegionsPopup = provinces.reduce(
      (acc, region) =>
        acc + '<option value="' + region.provinceCode + '">' + region.provinceName + '</option>',
      '<option value="0">Selecciona una región</option>'
    );
    popupProvinceSelect.innerHTML = htmlRegionsPopup;
    
    // Evento cambio de provincia en popup
    popupProvinceSelect.addEventListener('change', function() {
      const selectedProvinceCode = this.value;
      popupCitySelect.innerHTML = '<option value="0">Selecciona una comuna</option>';
      popupCitySelect.disabled = (selectedProvinceCode === '0');
      popupCitySelect.value = '0';
      
      if (selectedProvinceCode !== '0') {
        const selectedProvince = provinces.find(x => x.provinceCode == selectedProvinceCode);
        if (selectedProvince) {
          let htmlCitiesPopup = '<option value="0">Selecciona una comuna</option>';
          selectedProvince.provinceCities.forEach(
            x => (htmlCitiesPopup += '<option value="' + x.cityName + '">' + x.cityName + '</option>')
          );
          popupCitySelect.innerHTML = htmlCitiesPopup;
        }
      }
      
      window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.saveSelection();
      window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.updateHeaderButton();
      window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.syncSelectors('popup', selectedProvinceCode, null);
      
      document.dispatchEvent(new CustomEvent('shipping:location:changed', {
        detail: { province: selectedProvinceCode, city: null }
      }));
    });
    
    // Evento cambio de ciudad en popup
    popupCitySelect.addEventListener('change', function() {
      const citySelected = this.value !== '0';
      
      if (citySelected) {
        const provinceCode = popupProvinceSelect.value;
        const cityName = this.options[this.selectedIndex].text;
        
        window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.saveSelection();
        window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.updateHeaderButton();
        window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.syncSelectors('popup', provinceCode, cityName);
        
        document.dispatchEvent(new CustomEvent('shipping:location:changed', {
          detail: { province: provinceCode, city: cityName }
        }));
      }
    });
    
    // Restaurar selección guardada en el popup
    if (savedSelection.province && savedSelection.province !== '0') {
      popupProvinceSelect.value = savedSelection.province;
      popupProvinceSelect.dispatchEvent(new Event('change'));
      
      setTimeout(() => {
        if (savedSelection.city) {
          for (let i = 0; i < popupCitySelect.options.length; i++) {
            if (popupCitySelect.options[i].text === savedSelection.city) {
              popupCitySelect.selectedIndex = i;
              break;
            }
          }
        }
      }, 300);
    }
  };
})();

/* =========================================================================
   5. CART - Selector y calculo de tarifas dentro del carrito
   ========================================================================= */
(function() {
  'use strict';
  
  window.HACIENDOLA = window.HACIENDOLA || {};
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR = window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR || {};
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS = window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS || {};
  
  /**
   * Maneja el cambio de provincia en el selector del carrito
   */
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.provinceSelectChange = () => {
    const provinceSelect = document.getElementById('pscCartDropdownProvinceSelect');
    const citySelect = document.getElementById('pscCartDropdownCitySelect');
    if (!provinceSelect || !citySelect) return;

    const selectedProvinceCode = provinceSelect.value;

    const pscCartDropdownRatesPreviewWrapper = document.getElementById('pscCartDropdownRatesPreviewWrapper');
    if (pscCartDropdownRatesPreviewWrapper) {
      pscCartDropdownRatesPreviewWrapper.innerHTML = '';
    }

    citySelect.innerHTML = '<option value="0">' + window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.textValues['CHOOSE CITY TEXT'] + '</option>';
    
    if (selectedProvinceCode === '0') {
      citySelect.classList.add('hidden');
      window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.saveSelection();
      window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.updateHeaderButton();
      window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.syncSelectors('cart', null, null);
      
      document.dispatchEvent(new CustomEvent('shipping:location:changed', {
        detail: { province: null, city: null }
      }));
      return;
    }

    const selectedProvince = window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.provincesWithCities.find(
      (x) => x.provinceCode == selectedProvinceCode
    );
    
    if (!selectedProvince) return;

    let htmlCities = '<option value="0">' + window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.textValues['CHOOSE CITY TEXT'] + '</option>';
    selectedProvince.provinceCities.forEach(
      (x) => (htmlCities += '<option value="' + x.cityName + '">' + x.cityName + '</option>')
    );
    citySelect.innerHTML = htmlCities;
    citySelect.classList.remove('hidden');

    window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.updateHeaderButton();
    window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.saveSelection();
    window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.syncSelectors('cart', selectedProvinceCode, null);
    
    document.dispatchEvent(new CustomEvent('shipping:location:changed', {
      detail: { province: selectedProvinceCode, city: null }
    }));
  };

  /**
   * Maneja el cambio de ciudad en el selector del carrito y calcula tarifas
   */
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.citySelectChange = () => {
    const provinceSelect = document.getElementById('pscCartDropdownProvinceSelect');
    const citySelect = document.getElementById('pscCartDropdownCitySelect');
    const pscCartDropdownRatesPreviewWrapper = document.getElementById('pscCartDropdownRatesPreviewWrapper');
    
    if (!provinceSelect || !citySelect || !pscCartDropdownRatesPreviewWrapper) return;
    
    const provinceCode = provinceSelect.options[provinceSelect.selectedIndex].value;
    const cityName = citySelect.options[citySelect.selectedIndex].text;
    
    window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.saveSelection();
    window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.updateHeaderButton();
    window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.syncSelectors('cart', provinceCode, cityName);

    document.dispatchEvent(new CustomEvent('shipping:location:changed', {
      detail: { province: provinceCode, city: cityName }
    }));

    pscCartDropdownRatesPreviewWrapper.innerHTML = `<p style="color:#000;">${window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.textValues['CALCULATING RATES']}</p>`;
    
    fetch(
      `/cart/shipping_rates.json?shipping_address[country]=${window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.textValues['SHIPPING COUNTRY']}&shipping_address[province]=${provinceCode}&shipping_address[city]=${cityName}`
    )
      .then((res) => res.json())
      .then((res) => {
        if (res.error) {
          pscCartDropdownRatesPreviewWrapper.innerHTML =
            '<p style="margin: 0; font-weight: bold;">' + res.error[0] + '</p>';
          return;
        }
        
        const rates = res.shipping_rates;
        let finalHtml = '';
        
        if (rates.length === 0) {
          pscCartDropdownRatesPreviewWrapper.innerHTML = `<p style="color:#000;">${window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.textValues['NO RATES AVAILABLE']}</p>`;
        } else {
          finalHtml = '<p style="margin: 0; font-weight: bold; text-align: left !important;">'+ window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.textValues['AVAILABLE RATES'] +'</p>';
          
          rates.forEach((rate) => {
            const ignored = window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.ignoredRatesCode.findIndex((x) => x === rate.code) !== -1;
            if (!ignored) {
              finalHtml += `
                <div style="display: flex; justify-content: space-between;">
                  <p style="margin:0">${rate.name}</p>
                  <p style="margin:0">$${window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.numberformat(rate.price)}</p>
                </div>
              `;
            }
          });
          pscCartDropdownRatesPreviewWrapper.innerHTML = finalHtml;
        }
        
        document.dispatchEvent(new CustomEvent('shipping:rates:updated', {
          detail: { 
            rates: rates, 
            province: provinceCode, 
            city: cityName 
          }
        }));
      })
      .catch(err => console.error('Error fetching rates:', err));
  };

  /**
   * Configura los event listeners del carrito
   */
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.setupCartListeners = (provinceSelect, citySelect, provinces, savedSelection) => {
    const htmlRegions = provinces.reduce(
      (acc, region) =>
        acc + '<option value="' + region.provinceCode + '">' + region.provinceName + '</option>',
      '<option value="0">'+ window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.textValues['CHOOSE PROVINCE TEXT'] +'</option>'
    );

    provinceSelect.innerHTML = htmlRegions;
    provinceSelect.classList.remove('hidden');
    
    // Restaurar provincia seleccionada desde localStorage
    if (savedSelection.province && savedSelection.province !== '0') {
      provinceSelect.value = savedSelection.province;
    }
    
    // Remover listeners previos
    provinceSelect.removeEventListener('change', window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.provinceSelectChange);
    citySelect.removeEventListener('change', window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.citySelectChange);
    
    if (provinces.length === 1) {
      provinceSelect.value = provinces[0].provinceCode;
      provinceSelect.disabled = true;
      window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.provinceSelectChange();
    } else {
      provinceSelect.addEventListener('change', window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.provinceSelectChange);
    }

    // Si había una provincia seleccionada, cargar las ciudades
    if (provinceSelect.value && provinceSelect.value !== '0') {
      window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.provinceSelectChange();
      
      // Restaurar ciudad seleccionada después de un pequeño delay
      setTimeout(() => {
        if (savedSelection.city) {
          const citySelect = document.getElementById('pscCartDropdownCitySelect');
          if (citySelect) {
            for (let i = 0; i < citySelect.options.length; i++) {
              if (citySelect.options[i].text === savedSelection.city) {
                citySelect.selectedIndex = i;
                citySelect.value = citySelect.options[i].value;
                
                if (window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.showRates) {
                  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.citySelectChange();
                }
                break;
              }
            }
          }
        }
        
        window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.updateHeaderButton();
      }, 300);
    } else {
      window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.updateHeaderButton();
    }

    if(window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.showRates) {
      citySelect.addEventListener('change', window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.citySelectChange);
    }

    // Setup checkout buttons
    setTimeout(() => {
      const checkoutButtons = document.getElementsByName(window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.goToCheckoutButtonName);
      checkoutButtons.forEach(btn => {
        const newBtn = btn.cloneNode(true);
        btn.parentNode.replaceChild(newBtn, btn);
        
        newBtn.addEventListener('click', (event) => {
          const citySelect = document.getElementById('pscCartDropdownCitySelect');
          const provinceSelect = document.getElementById('pscCartDropdownProvinceSelect');
          if (!citySelect || !provinceSelect) return;
          
          if (citySelect.selectedIndex === 0 && window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.forceCitySelection) {
            event.stopPropagation();
            event.preventDefault();
            alert(window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.textValues['FORCE SELECTION MESSAGE']);
            return false;
          }
          
          if (citySelect.selectedIndex > 0) {
            const selectedCityText = citySelect.options[citySelect.selectedIndex].text;
            const selectedProvinceCode = provinceSelect.options[provinceSelect.selectedIndex].value;
            const form = document.getElementById(window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.cartCheckoutFormId);
            if (form) {
              form.action = `/cart?checkout[shipping_address][country]=${window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.textValues['SHIPPING COUNTRY']}&checkout[shipping_address][province]=${selectedProvinceCode}&checkout[shipping_address][city]=${selectedCityText}`;
            }
          }
        });
      });
    }, 100);

    // Set title
    const title = document.getElementById('pscCartDropdownTitle');
    if (title) {
      title.innerHTML = window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.textValues['SNIPPET TITLE'];
    }
  };
})();

/* =========================================================================
   6. INIT - Orquestador. Debe ir despues de STORAGE/UI/SYNC/POPUP/CART
   porque su initialize() corre apenas se parsea el archivo.
   ========================================================================= */
(function() {
  'use strict';

  /* ========================================
     CONFIGURACIÓN Y CONSTANTES
     ======================================== */
  window.HACIENDOLA = window.HACIENDOLA || {};
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR = window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR || {};
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS = window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS || {};
  
  // Obtener el shop URL del meta tag o del objeto Shopify
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.shopUrl = 
    window.Shopify?.shop || 
    document.querySelector('meta[property="og:url"]')?.content?.match(/https?:\/\/([^\/]+)/)?.[1] ||
    window.location.hostname || 
    '';
  
  /* CUSTOMIZABLE VALUES BEGIN */
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.goToCheckoutButtonName = 'checkout';
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.cartCheckoutFormId = 'cart_form';
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.forceCitySelection = false;
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.showRates = true;
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.decimalValues = 0;
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.ignoredRatesCode = [];

  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.textValues = {
    'SNIPPET TITLE': 'Comuna de envío',
    'LOADING TEXT': 'Cargando...',
    'CHOOSE PROVINCE TEXT': '¿Región?',
    'CHOOSE CITY TEXT': '',
    'FORCE SELECTION MESSAGE': 'Debes seleccionar una región y comuna antes de continuar.',
    'CALCULATING RATES': 'Calculando tarifas...',
    'NO RATES AVAILABLE': 'No hay tarifas disponibles para este carrito.',
    'AVAILABLE RATES': 'Tarifas disponibles',
    'SHIPPING COUNTRY': 'Chile',
  };
  /* CUSTOMIZABLE VALUES END */

  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.provincesWithCities = [];
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.dataLoaded = false;

  /* ========================================
     CONFIGURACIÓN DE EVENT LISTENERS (CORREGIDO)
     ======================================== */
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.setupEventListeners = () => {
    // 1. Verificamos que tengamos datos de provincias cargados
    const provinces = window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.provincesWithCities;
    if (!provinces || provinces.length === 0) return;

    // 2. Cargar selección guardada (LocalStorage)
    const savedSelection = window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.loadSelection();

    // 3. INTENTO DE CARGA: Selectores del CARRITO
    // Solo intentamos configurarlos si existen en el DOM
    const provinceSelectCart = document.getElementById('pscCartDropdownProvinceSelect');
    const citySelectCart = document.getElementById('pscCartDropdownCitySelect');
    
    if (provinceSelectCart && citySelectCart) {
        window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.setupCartListeners(provinceSelectCart, citySelectCart, provinces, savedSelection);
    }

    // 4. INTENTO DE CARGA: Selectores del POPUP HEADER
    // Intentamos configurarlos independientemente de si el carrito existe o no
    if (window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.setupPopupListeners) {
        window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.setupPopupListeners(provinces, savedSelection);
    }
  };

  /* ========================================
     INICIALIZACIÓN
     ======================================== */
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.init = () => {
    if (window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.dataLoaded) {
      window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.setupEventListeners();
    } else {
      const shopUrl = window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.shopUrl;
      if (!shopUrl) {
        console.error('Shop URL not found');
        return;
      }

      fetch(
        `https://prod.haciendola.dev/backend/tarificadorww/api/provinces/getShopEnabledProvinces/${shopUrl}`
      )
        .then((response) => response.json())
        .then((result) => {
          window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.provincesWithCities = result;
          window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.dataLoaded = true;
          window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.setupEventListeners();
        })
        .catch(err => console.error('Error loading provinces:', err));
    }
  };

  /* ========================================
     ARRANQUE DEL SISTEMA
     ======================================== */
  const initialize = () => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.init);
    } else {
      window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.init();
    }

    // Escuchar actualizaciones del carrito
    document.addEventListener('cart:updated', () => {
      setTimeout(() => {
        window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.init();
      }, 800);
    });

    // Observar cambios en el DOM del carrito
    const observer = new MutationObserver(() => {
      const provinceSelect = document.getElementById('pscCartDropdownProvinceSelect');
      // Solo reiniciamos si detectamos cambios en el select del carrito, pero no bloqueamos el resto
      if (provinceSelect && (!provinceSelect.options || provinceSelect.options.length <= 1)) {
        setTimeout(() => {
          window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.init();
        }, 200);
      }
    });

    // Observar el cart drawer
    const observeCart = () => {
      const cartElement = document.querySelector('cart-items-component, .cart-drawer, [data-cart-drawer]');
      if (cartElement) {
        observer.observe(cartElement, { childList: true, subtree: true });
      } else {
        // Si no encuentra el carrito, reintentamos un par de veces pero no infinito para no saturar
        // setTimeout(observeCart, 500); 
        // Comentado para evitar bucles infinitos si no hay carrito en home
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeCart);
    } else {
      observeCart();
    }
    
    // Actualizar el header cuando se cargue la página
    setTimeout(() => {
        // Aseguramos que la función exista antes de llamarla
        if(window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.updateHeaderButton) {
            window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.updateHeaderButton();
        }
    }, 1000);
  };

  initialize();
})();

/* =========================================================================
   7. BAR - Barra de envio gratis y contador ETA. Scope propio, se
   autoinicializa y escucha los eventos que emiten los bloques anteriores.
   ========================================================================= */
(function() {
  'use strict';

  const CLOCK_SVG = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" style="width: 18px; height: 18px; vertical-align: middle; margin-right: 4px; display: inline-block;">
  <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
</svg>`;

  let MIN_CENTS = 0;
  let widget = null;
  let etaEl = null;
  let fillEl = null;
  let textEl = null;
  let headerTitleEl = null; 
  let originalHeaderTitle = ''; 
  let isStarkenZoneGlobal = false;

  const TODAY_DELIVERY_COMMUNES = [
    "Estación Central", "Huechuraba", "Independencia", "La Reina", "Las Condes", 
    "Lo Barnechea", "Macul", "Maipu", "Ñuñoa", "Peñalolén", 
    "Providencia", "Pudahuel", "Quilicura", "Renca", "San Miguel", 
    "Santiago", "Vitacura"
  ];

  const FIXED_DELIVERY_COMMUNES = [
    "Cerrillos", "Cerro Navia", "El Bosque", "La Cisterna", "La Florida", 
    "La Granja", "Lo Espejo", "Lo Prado", "Puente Alto", "Quinta Normal", 
    "Recoleta", "San Bernardo", "San Joaquín", "San Ramón"
  ];

  const loadSelection = () => {
    try {
      const saved = localStorage.getItem('haciendola_shipping_selection');
      if (saved) {
        const selection = JSON.parse(saved);
        if (Date.now() - selection.timestamp < 3600000) {
          return selection;
        }
      }
    } catch(e) {}
    return { province: null, city: null };
  };

  const normalizeText = (text) => {
    if (!text) return null;
    return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase().trim();
  };

  // Esta función está CORREGIDA y es la clave
  const determineShippingZone = () => {
    const savedSelection = loadSelection();
    const selectedCity = normalizeText(savedSelection.city); 
    
    if (!selectedCity) {
        isStarkenZoneGlobal = false;
        return { isStarken: false, isFixedZone: false, isTodayTomorrowZone: false };
    }

    const isFixedZone = FIXED_DELIVERY_COMMUNES.some(commune => normalizeText(commune) === selectedCity);
    const isTodayTomorrowZone = TODAY_DELIVERY_COMMUNES.some(commune => normalizeText(commune) === selectedCity);
    const isStarken = !isFixedZone && !isTodayTomorrowZone; 
    
    isStarkenZoneGlobal = isStarken; 
    return { isStarken, isFixedZone, isTodayTomorrowZone };
  };

  function nowChile() {
    const str = new Date().toLocaleString("en-US", { timeZone: "America/Santiago", hour12: false });
    const [mdy, time] = str.split(", ");
    const [m, d, y] = mdy.split("/").map(Number);
    const [H, M, S] = time.split(":").map(Number);
    return new Date(y, m - 1, d, H, M, S);
  }

  // Esta función está CORREGIDA (Muestra "Selecciona...")
  function updateETA() {
    if (!etaEl || !headerTitleEl) return;
    
    const savedSelection = loadSelection();
    const selectedCity = normalizeText(savedSelection.city);

    if (!selectedCity) {
        headerTitleEl.innerHTML = originalHeaderTitle; 
        etaEl.innerHTML = '<span style="color:#333;">Selecciona una dirección para ver tiempos de envío</span>';
        return; 
    }

    const now = nowChile();
    const cutoff = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 13, 0, 0);
    const tomorrowCutoff = new Date(cutoff);
    tomorrowCutoff.setDate(tomorrowCutoff.getDate() + 1);

    const { isStarken, isFixedZone, isTodayTomorrowZone } = determineShippingZone();
    const isBeforeCutoff = now < cutoff;
    
    let targetTime;
    let textoETA;

    // Starken = Región
    if (isStarken) {
      headerTitleEl.innerHTML = `Su pedido será enviado por <span style="color:#333;">Starken hoy mismo</span>`;
      etaEl.innerHTML = ''; 
      return; 
    } else {
      headerTitleEl.innerHTML = originalHeaderTitle;
    }
    
    // ✅ CAMBIO: Ambas zonas (FIXED y TODAY_TOMORROW) usan la misma lógica de tiempo
    if (isFixedZone || isTodayTomorrowZone) {
      targetTime = isBeforeCutoff ? cutoff : tomorrowCutoff;
    } else {
      targetTime = tomorrowCutoff;
    }

    let diff = targetTime - now;
    
    if (diff <= 0) {
        targetTime = tomorrowCutoff;
        diff = targetTime - now;
    }

    const hours = Math.floor(diff / 1000 / 3600);
    const minutes = Math.floor((diff / 1000 % 3600) / 60);
    const seconds = Math.floor(diff / 1000 % 60);
    const h = hours.toString().padStart(2, "0");
    const m = minutes.toString().padStart(2, "0");
    const s = seconds.toString().padStart(2, "0");
    const timeStr = `${h}:${m}:${s}`;

    // ✅ CAMBIO: FIXED_ZONE ahora muestra HOY/MAÑANA igual que TODAY_TOMORROW
    if (isFixedZone) {
        if (isBeforeCutoff) {
            // Antes de las 13:00 → HOY
            textoETA = ` ${CLOCK_SVG} Aprovecha, compra en <strong id="countdown-time">${timeStr}</strong> y recibe <span style="font-size: 13.5px; line-height: 1.45; color: #333; font-weight: 400;">HOY</span>`;
        } else {
            // Después de las 13:00 → MAÑANA
            textoETA = ` ${CLOCK_SVG} Tu pedido llega <span style="font-size: 13.5px; line-height: 1.45; color: #333; font-weight: 400;">MAÑANA</span> comprando antes de <strong id="countdown-time">${timeStr}</strong>`;
        }
    } else if (isTodayTomorrowZone) {
        if (isBeforeCutoff) {
            // Antes de las 13:00 → HOY
            textoETA = ` ${CLOCK_SVG} Aprovecha, compra en <strong id="countdown-time">${timeStr}</strong> y recibe <span style="font-size: 13.5px; line-height: 1.45; color: #333; font-weight: 400;">HOY</span>`;
        } else {
            // Después de las 13:00 → MAÑANA
            textoETA = ` ${CLOCK_SVG} Tu pedido llega <span style="font-size: 13.5px; line-height: 1.45; color: #333; font-weight: 400;">MAÑANA</span> comprando antes de <strong id="countdown-time">${timeStr}</strong>`;
        }
    } else {
        // Otras zonas (no debería llegar aquí, pero por seguridad)
        textoETA = ` ${CLOCK_SVG} Tu pedido llega <span style="font-size: 13.5px; line-height: 1.45; color: #333; font-weight: 400;">MAÑANA</span> comprando antes de <strong id="countdown-time">${timeStr}</strong>`;
    }

    etaEl.innerHTML = textoETA;
  }
  
  //
  // ✅ CAMBIO FINAL: FUNCIÓN 'applyCartToBar' CORREGIDA
  //
  function applyCartToBar(cart) {
    if (!fillEl || !textEl) return;
    
    const CART_CENTS = Number(cart.total_price || 0);
    const pctRaw = MIN_CENTS ? Math.min(100, Math.floor((CART_CENTS * 100) / MIN_CENTS)) : 0;
    
    const isStarken = isStarkenZoneGlobal; 

    fillEl.classList.remove('low','mid','high');
    
    if (isStarken) {
        // ✅ CAPRICHO COMERCIAL: Si es Región, barra verde 100%
        fillEl.classList.add('high');
        fillEl.style.width = '100%';
    } else {
        // Lógica normal para RM
        if (CART_CENTS >= MIN_CENTS) {
            fillEl.classList.add('high');
            fillEl.style.width = '100%';
        } else if (pctRaw >= 50) {
            fillEl.classList.add('mid');
            fillEl.style.width = pctRaw + '%';
        } else {
            fillEl.classList.add('low');
            fillEl.style.width = pctRaw + '%';
        }
    }
    
    if (isStarken) {
        // ✅ CAPRICHO COMERCIAL: Si es Región, SIN TEXTO
        textEl.innerHTML = ''; 
    } else {
        // Lógica normal de texto para RM
        if (CART_CENTS >= MIN_CENTS) {
            textEl.innerHTML = '<spam style="color:#333;">¡Ya tienes <strong style="#333">envío gratis!</strong></spam> 🎉';
        } else {
            const faltante = MIN_CENTS - CART_CENTS;
            const faltanteFmt = new Intl.NumberFormat('es-CL', { 
                style: 'currency', 
                currency: 'CLP', 
                minimumFractionDigits: 0, 
                maximumFractionDigits: 0 
            }).format(faltante / 100);
            textEl.innerHTML = '<spam style="color:#333;">Te faltan ' + faltanteFmt + ' para <strong style="#333;">envío gratis</strong></spam>';
        }
    }
  }

  // Esta función está bien, llama a 'applyCartToBar' que ahora es correcta
  async function refreshShippingBar() {
    determineShippingZone(); 
    
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!res.ok) return;
      const cart = await res.json();
      applyCartToBar(cart); // Esta función ahora hace lo correcto

      // Ya no necesitamos lógica de barra verde aquí, 'applyCartToBar' se encarga de todo
    } catch (e) {
      console.error('Error refreshing shipping bar:', e);
    }
  }

  function initShippingBar() {
    widget = document.querySelector("#shipping-bar");
    if (!widget) return;

    MIN_CENTS = Number(widget.dataset.minCents || 0);
    etaEl = widget.querySelector(".ship-eta");
    fillEl = widget.querySelector(".ship-fill");
    textEl = widget.querySelector(".ship-text");
    
    headerTitleEl = widget.querySelector(".ship-title");
    if (headerTitleEl) {
        originalHeaderTitle = headerTitleEl.innerHTML;
    }

    if (!etaEl || !fillEl || !textEl || !headerTitleEl) return;

    updateETA();
    setInterval(updateETA, 1000);

    refreshShippingBar();
    
    setupAggressiveListeners();
  }

  const initialize = () => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initShippingBar);
    } else {
      initShippingBar();
    }

    //
    // ✅ LISTENERS DE SINCRONIZACIÓN (Correctos)
    //
    
    // 1. Escuchar cuando el usuario cambia la comuna/ubicación
    // Llama a updateETA y refreshShippingBar, que ahora tienen la lógica correcta.
    document.addEventListener('shipping:location:changed', function(e) {
        updateETA();
        refreshShippingBar(); 
    });

    // 2. Escuchar cuando las tarifas de envío ya fueron recibIDAS
    // Llama a updateETA y refreshShippingBar, que ahora tienen la lógica correcta.
    document.addEventListener('shipping:rates:updated', function(e) {
        updateETA();
        refreshShippingBar(); 
    });
    
    //
    // ✅ FIN DE CAMBIOS
    //

    document.addEventListener('cart:updated', () => {
      setTimeout(refreshShippingBar, 300);
      setTimeout(setupAggressiveListeners, 500);
    });

    const observer = new MutationObserver(() => {
      const cartBubble = document.querySelector('.cart-bubble, [data-cart-count]');
      if (cartBubble) {
        setTimeout(refreshShippingBar, 300);
        setTimeout(setupAggressiveListeners, 500);
      }
    });

    const observeCartIcon = () => {
      const cartIcon = document.querySelector('.header-actions__action, cart-drawer-component, [data-cart-drawer]');
      if (cartIcon) {
        observer.observe(cartIcon, { childList: true, subtree: true, characterData: true });
      } else {
        setTimeout(observeCartIcon, 500);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeCartIcon);
    } else {
      observeCartIcon();
    }

    if (window.fetch) {
      const _fetch = window.fetch.bind(window);
      window.fetch = async function(...args) {
        const result = await _fetch(...args);
        
        try {
          const url = (args[0] && args[0].url) || args[0];
          if (typeof url === 'string' && /\/cart\/(add|change|update|clear)\.js(\?|$)/.test(url)) {
            setTimeout(refreshShippingBar, 200);
          }
        } catch(e) {}
        
        return result;
      };
    }

    (function() {
      const _open = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function(method, url, ...rest) {
        this.addEventListener('load', () => {
          try {
            if (typeof url === 'string' && /\/cart\/(add|change|update|clear)\.js(\?|$)/.test(url)) {
              setTimeout(refreshShippingBar, 200);
            }
          } catch(e) {}
        });
        return _open.call(this, method, url, ...rest);
      };
    })();

    document.addEventListener('submit', function(e) {
      const form = e.target;
      if (form && form.action && /\/cart\/add(\.js)?/.test(form.action)) {
        setTimeout(refreshShippingBar, 400);
      }
    }, true);
    
    document.addEventListener('click', aggressiveClickListener, true);
    document.addEventListener('change', aggressiveChangeListener, true);
  };

  function setupAggressiveListeners() {
      document.removeEventListener('click', aggressiveClickListener, true);
      document.removeEventListener('change', aggressiveChangeListener, true);

      document.addEventListener('click', aggressiveClickListener, true);
      document.addEventListener('change', aggressiveChangeListener, true);
  }

  const aggressiveClickListener = (e) => {
    const el = e.target;
    const isQuantityButton = el.matches('.quantity__button, button[name="plus"], button[name="minus"], button[name="update"]');
    const isRemoveButton = el.closest('.cart-items__remove, [aria-label*="Eliminar"], [data-line-item-remove]');
    const isInput = el.tagName === 'INPUT' && (/\bupdates\[/i.test(el.name) || el.name === 'quantity' || el.name === 'updates[]');

    if (isQuantityButton || isRemoveButton || isInput) {
        setTimeout(refreshShippingBar, 500); 
    }
  };
  
  const aggressiveChangeListener = (e) => {
    const el = e.target;
    if (el.tagName === 'INPUT' && (/\bupdates\[/i.test(el.name) || el.name === 'quantity' || el.name === 'updates[]')) {
        setTimeout(refreshShippingBar, 300);
    }
  };

  initialize();
})();